// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -------- */
/* SHARED */
/* -------- */
#splash-page {
  --ce-h1: var(--ce-marketing-h1);
  --ce-h2: var(--ce-marketing-h2);
  --ce-h3: var(--ce-marketing-h3);
  --ce-h4: var(--ce-marketing-h4);
  --ce-h5: var(--ce-marketing-h5);
  --ce-h6: var(--ce-marketing-h6);
  font-size: var(--ce-marketing-body-default);
  line-height: 1.4;
  background: #F6FAFD;
}
#splash-page h1,
#splash-page h2,
#splash-page h3,
#splash-page h4,
#splash-page h5,
#splash-page h6
{
  font-family: var(--ce-font-family-title-marketing);
}

.gradient-text {
    -webkit-text-fill-color: transparent;
    -moz-text-fill-color: transparent;
    -webkit-background-clip: text;
    -moz-background-clip: text;
    background-color: #4e44c2;
    background-image: linear-gradient(90deg, #4e44c2, #f3617b);
    background-size: 100%;
}

img {
  max-width: 100%;
  height: auto;
}

.text-wrap {
  padding: 0 1rem;
}

#splash-page section {
  overflow: hidden;
  padding: var(--section-padding) 3rem;
}

#splash-page h2,
#splash-page h3,
#splash-page h5 {
  margin-top: 0;
  padding-bottom: 0;
  line-height: 1.25;
}

#splash-page h2 {
  margin-bottom: 10px;
}

#splash-page h5 {
  margin-bottom: 0;
}

.container {
  display: flex;
  gap: 30px;
  flex-direction: column;
  padding: 0 var(--ce-base-padding-default);
}

/* buttons */

.button-group {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: var(--ce-base-padding-default);
  padding: 30px 0;
}
.button-group a {
  min-width: calc(50% - var(--ce-base-padding-default));
}

#splash-page .join-button,
#splash-page .login-button {
  flex: 1;
}

@media only screen and (min-width: 768px) {
  #splash-page .join-button,
  #splash-page .login-button {
    width: 180px !important;
    flex: initial;
  }
}

/* icon bullets */

.icon-bullets {
  list-style: none;
  padding: 20px 0;
  margin: 0;
  gap: 10px;
  display: flex;
  flex-direction: column;
}

.icon-bullets li {
  display: flex;
  align-items: flex-start;
  gap: 15px;
}

.icon-bullets .icon-bullets {
  padding: 0 3rem;
  gap: 1.5rem;
}

#splash-page .icon-bullets h5 {
  margin-bottom: 0;
}


.icon-wrap {
  border-radius: 50%;
  width: 16px;
  height: 40px;
  display: flex;
  flex: none;
  padding: 0;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}
.icon-wrap .fa-check {
  font-size: 18px;
  color: var(--ce-green-40);
}
@media only screen and (min-width: 768px) {
  .icon-bullets .icon-bullets {
    padding: 0 4rem;
  }
  .icon-wrap {
    width: 40px;
  }
  .icon-wrap .fa-check {
    font-size: 24px;
  }
}

.icon-wrap img {
  max-width: 100%;
  max-height: 100%;
  height: auto;
  margin: 0 auto;
}


/* Graphics */
.graphics svg {
  width: 100%;
  height: auto;
}

/* Mobile Portrait */
@media only screen and (max-width: 767px) {
  #splash-page section {
    overflow: hidden;
    padding: var(--section-padding) 1rem;
  }

  .col-2 > div:first-of-type {
    padding-bottom: 1em;
  }
  .image-wrap img {
    width: 60vh;
    margin: 0 auto;
    display: block;
  }
  .image-wrap {
    height: 25vh;
    min-height: 200px;
  }
  .text-wrap {
    padding: 0;
  }
}
/* Desktop */
@media only screen and (min-width: 768px) {
  .container {
    max-width: 1200px;
    margin: 0 auto;
  }
  .col-2 {
    flex-direction: row;
  }
  .col-2 > div {
    width: 50%;
  }

  .col-2 > .text-wrap {
    width: 55%;
  }
  .col-2 > .image-wrap {
    width: 45%;
  }

  .container.align-top {
    align-items: flex-start;
  }
  .container.align-center {
    align-items: center;
  }
  .container.align-stretch {
    align-items: stretch;
  }
  .container.align-bottom {
    align-items: flex-end;
  }

  .image-wrap.align-bottom .moving-image {
    position: absolute;
    width: 100%;
  }
}

/* Blockquotes */

.blockquote {
  position: relative;
  margin: var(--ce-base-padding-default) 0;
}

.quote {
  position: relative;
  font-family: var(--ce-font-family-title-marketing);
  font-weight: var(--ce-font-weight-semibold);
  font-size: var(--ce-h4);
  line-height: 1.25;
  margin: 0;
}

.quote::before {
  content: open-quote;
}
.quote::after {
  content: close-quote;
}

.cite {
  display: block;
  font-size: var(--ce-body-default);
  margin-top: var(--ce-base-padding-default);
  padding-left: 30px;
  position: relative;
}
.cite::before {
  content: '—';
  position: absolute;
  left: 7px;
}


/* -------- */
/* SECTIONS */
/* -------- */

/* Hero */
#splash-page section.hero {
  background: linear-gradient(180deg, #E7E6F9 0%, #F3DFDB 100%);
  padding: 0;
  position: relative;
  margin: 0 auto;
  display: flex;
  flex-direction: column-reverse;
}
#splash-page section.hero .container {
  padding: 0;
}
.hero .text-wrap {
  padding: 0 2rem;
}
@media only screen and (min-width: 768px) {
  #splash-page section.hero {
    flex-direction: row;
  }
  .hero .text-wrap {
    padding: 0 2em 2em 4em;
  }
  .hero h2 {
    max-width: 620px;
  }
  .hero .landscape-background,
  .hero .text-background {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    overflow: hidden;
  }
  .hero .text-background {
    background: linear-gradient(90deg, #F6FAFD 40%, rgba(255, 255, 255, 0.00) 60%);
  }
  .hero .landscape-background img {
    max-width: 100%;
    position: absolute;
    max-height: 100%;
    right: -25%;
    bottom: 0;
  }
}
@media only screen and (max-width: 767px) {
  .hero .landscape-background {
    margin-bottom: -16%;
    width: 231%;
    left: -69.2%;
    position: relative;
    margin-top: -26%;
  }
}
@media only screen and (min-width: 768px) {
  section.hero .col-2 > .text-wrap {
    width: 100%;
  }
  section.hero .col-2 .text-wrap-small {
    width: 55%;
  }
}
@media only screen and (min-width: 1024px) {
  .hero .landscape-background img{
    right: -300px;
    bottom: -10%;
  }
}
@media only screen and (min-width: 1600px) {
  .hero .landscape-background img{
    right: -15%;
  }
}
@media only screen and (min-width: 1700px) {
  .hero .landscape-background img{
    right: -10%;
  }
}
@media only screen and (min-width: 1900px) {
  .hero .landscape-background img{
    right: -5%;
  }
}
@media only screen and (min-width: 2100px) {
  .hero .landscape-background img{
    right: 0;
  }
}
@media only screen and (min-width: 2300px) {
  .hero .landscape-background img{
    right: 0;
  }
  .hero .text-background {
    background: linear-gradient(90deg, #F6FAFD 40%, rgba(255, 255, 255, 0.00) 60%, #F6FAFD 95%);
  }
    #splash-page section.hero {
    --hero-max-width: 2300px;
    max-width: var(--hero-max-width);
  }
  #splash-page section.hero .container {
    height: 620px;
  }
}

.hero .what-is-mdh-description {
  margin-bottom: 10px;
}

.image-wrap {
  position: relative;
}

.moving-image {
  position: absolute;
}

/* ----------- */
/* ----------- */
/* Trusted By */
/* ----------- */
/* ----------- */

.trusted-by {
  border-top: 1px solid var(--ce-grey-10);
  border-bottom: 1px solid var(--ce-grey-10);
  padding: var(--section-padding) 2rem;
  background: #fff;
}
.trusted-by .header,
.trusted-by p {
  text-align: center;
  color: var(--ce-grey-55);
}
.trusted-by .header {
  margin: 0 auto 1em auto;
}
.trusted-by p {
  margin: 1.5em auto 0 auto;
  color: var(--default_text_color);
  font-weight: 600;
}
.trusted-logos {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  list-style-type: none;
  height: 90px;
  gap: 0;
}

.trusted-logos li {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 5px 15px;
}

.trusted-logos img {
  max-height: 50px;
  margin: 0 auto;
  display: block;
}

.logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
/* Trusted logos fade animation */
.trusted-logos-container {
  position: relative;
  min-height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.trusted-logos.fade-in {
  opacity: 1;
  transition: opacity 0.6s ease-in-out;
}

.trusted-logos.fade-out {
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}
@media only screen and (max-width: 576px) {
  .trusted-logos li {
    width: 50%;
  }
}
@media only screen and (max-width: 767px) {
  .trusted-logos {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    padding: 0;
    height: 200px;
  }
}

.logo-text {
  text-align: center;
  max-height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 800;
  color: var(--ce-grey-40);
}
@media only screen and (min-width: 768px) {
  .logo-text {
    font-size: 20px;
  }
}
@media only screen and (min-width: 1200px) {
  .logo-text {
    font-size: 24px;
  }
}



/* Section 1 */

.section-1 {
  background: var(--ce-grey-3);
}

@media only screen and (min-width: 768px) {
  .section-1 .container {
    flex-direction: row-reverse;
  }
}

.section-wrap .icon-wrap {
  color: var(--ce-blue-vivid-50);
}

.section-1 .image-wrap .moving-image,
.section-1-dial {
  position: absolute;
  max-width: 50%;
}
.section-1-image-1 {
  left: 2%;
  top: 10%;
}
.section-1-image-2 {
  left: 25%;
  top: 20%;
}
.section-1-dial {
  top: 10%;
  left: 15%;
  width: 50%;
}

@media only screen and (max-width: 767px) {
  .section-1-image-1 {
    top: 0;
    left: 30%;
  }
  .section-1-image-2 {
    top: 10%;
    left: 10%;
  }
  .section-1-dial {
    top: -10%;
    left: 24%;
  }
}

/* How it works */
.section-2 {
  background: var(--ce-gradient-open-horizon);
  text-align: center;
}
.how-it-works-graphic {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  list-style: none;
  gap: 20px;
  flex-wrap: wrap;
}
.how-it-works-graphic img {
  max-width: 100%;
  max-height: 100%;
}
.how-it-works-graphic li{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  max-width: 150px;
}
@media screen and (min-width: 768px) {
  .how-it-works-graphic li {
    width: 31.3333%;
    max-width: initial;
  }
  .how-it-works-graphic img{
    max-height: 200px;
    max-width: initial;
  }
}
.how-it-works-graphic h3 div {
  color: var(--ce-grey-55);
  display: flex;
  justify-content: center;
  gap: 10px;
  text-align: left;
}
.how-it-works-graphic span {
  font-size: var(--ce-h1);
  color: #fff;
  line-height: 100%;
  position: relative;
  top: -1px;
}

/* section-3 */
.section-3 {
  background: #fff;
}
.section-3-section {
  padding: 30px 0;
}
.section-3-section:first-of-type {
  border-bottom: 1px solid var(--ce-grey-55);
}
.section-3-section img {
  padding-bottom: 20px;
}
.section-3-section .icon-bullets {
  padding-bottom: 0;
}

.list-button-group {
  display: flex;
  align-items: flex-end;
  gap: 15px;
  justify-content: space-between;
  flex-wrap: wrap;
}

.section-3 .image-wrap {
  position: relative;
  top: -30px;
}

.section-3 .image-wrap .moving-image,
.section-3-dial {
  position: absolute;
  max-width: 50%;
}
.section-3-1 {
  left: 36%;
  top: 10%;
}
.section-3-2 {
  left: 5%;
  top: 23%;
}
.section-3-dial {
  top: 50%;
  left: 38%;
  width: 50%;
}

@media only screen and (max-width: 767px) {
  .section-3 .image-wrap {
    top: 0;
  }
  .section-3 .image-wrap .moving-image,
  .section-3-dial {
    max-width: 45%;
  }
}

/* section-4 */

.section-4 {
  background: var(--ce-gradient-evergreen-petrichor);
}

.section-4-dial {
  position: absolute;
  top: 0;
  left: 10%;
  width: 50%;
}
.section-4 .image-wrap .moving-image,
.section-4-dial {
  position: absolute;
  max-width: 50%;
}
.section-4-image-1 {
  left: 2%;
  top: 10%;
}
.section-4-image-2 {
  left: 25%;
  top: 30%;
}
.section-4-dial {
  top: 20%;
  left: 15%;
  width: 50%;
}

@media only screen and (max-width: 767px) {
  .section-4 > .container {
    flex-direction: column-reverse;
  }
  .section-4 .image-wrap {
    top: 20px;
  }
  .section-4-image-1 {
    top: 10%;
  }
  .section-4-image-2 {
    top: 20%;
  }
  .section-4-dial {
    top: 00%;
  }
}


/* help section */

.help-section {
  text-align: center;
  align-items: center;
  background: #fff;
}

.help-center-button.intent-none.button.variant-filled {
  border: 1px solid #000;
  background-color: transparent;
  color: #000;
  width: 180px !important;
  margin: 0 auto;
}


/* join section */

.join-section{
  background: var(--ce-gradient-midnight-moon);
}

.join-section .container {
  text-align: center;
  align-items: center;
}


/* app store */

.app-store {
  text-align: center;
}

.app-stores {
  max-width: 100%;
  padding: 0;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 1em;
}

.app-stores img {
  height: 60px;
  width: auto;
}

/* Login */

.login-section {
  background: var(--ce-gradient-midnight-moon);
  padding: 150px 0;
}

@media only screen and (max-width: 767px) {
  .login-section {
    padding: 80px 20px;
  }
}

.login-section h3 {
  margin-top: 0px;
}

.login-card {
  max-width: 660px;
  margin: 0 auto 5px;
  padding: 50px 70px;
  border-radius: var(--ce-border-radius-default);
  background-color: var(--ce-grey-1);
  box-shadow: var(--ce-card-shadow);
  border: 1px solid var(--ce-grey-20);
}

@media only screen and (max-width: 767px) {
  .login-card {
    padding: 30px;
  }
  .login-card .button-group {
    flex-wrap: wrap;
    padding: var(--ce-base-padding-default) 0;
  }
}

.mdh-logo-login {
  max-width: 240px;
  margin-bottom: 1em;
}

`, "",{"version":3,"sources":["webpack://./src/components/Authentication/Participant/ParticipantLanding.css"],"names":[],"mappings":"AAAA,aAAa;AACb,WAAW;AACX,aAAa;AACb;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,2CAA2C;EAC3C,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;;;;;;EAOE,kDAAkD;AACpD;;AAEA;IACI,oCAAoC;IACpC,iCAAiC;IACjC,6BAA6B;IAC7B,0BAA0B;IAC1B,yBAAyB;IACzB,0DAA0D;IAC1D,qBAAqB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;;;EAGE,aAAa;EACb,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA,YAAY;;AAEZ;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mCAAmC;EACnC,eAAe;AACjB;AACA;EACE,qDAAqD;AACvD;;AAEA;;EAEE,OAAO;AACT;;AAEA;EACE;;IAEE,uBAAuB;IACvB,aAAa;EACf;AACF;;AAEA,iBAAiB;;AAEjB;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,SAAS;EACT,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,UAAU;EACV,UAAU;EACV,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;;AAGA,aAAa;AACb;EACE,WAAW;EACX,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE;IACE,gBAAgB;IAChB,oCAAoC;EACtC;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,cAAc;IACd,cAAc;EAChB;EACA;IACE,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;AACF;AACA,YAAY;AACZ;EACE;IACE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;;EAEA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;AACF;;AAEA,gBAAgB;;AAEhB;EACE,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD,2CAA2C;EAC3C,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;AACX;;;AAGA,aAAa;AACb,aAAa;AACb,aAAa;;AAEb,SAAS;AACT;EACE,6DAA6D;EAC7D,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;;IAEE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,gBAAgB;EAClB;EACA;IACE,8EAA8E;EAChF;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,SAAS;EACX;AACF;AACA;EACE;IACE,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;EAClB;AACF;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,aAAa;IACb,YAAY;EACd;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,QAAQ;EACV;AACF;AACA;EACE;IACE,QAAQ;EACV;EACA;IACE,2FAA2F;EAC7F;IACE;IACA,wBAAwB;IACxB,gCAAgC;EAClC;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB,gBAAgB;AAChB,eAAe;AACf,gBAAgB;AAChB,gBAAgB;;AAEhB;EACE,uCAAuC;EACvC,0CAA0C;EAC1C,oCAAoC;EACpC,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,YAAY;EACZ,MAAM;AACR;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,oCAAoC;AACtC;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;;;;AAIA,cAAc;;AAEd;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,QAAQ;EACR,QAAQ;AACV;AACA;EACE,SAAS;EACT,QAAQ;AACV;AACA;EACE,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;IACE,MAAM;IACN,SAAS;EACX;EACA;IACE,QAAQ;IACR,SAAS;EACX;EACA;IACE,SAAS;IACT,SAAS;EACX;AACF;;AAEA,iBAAiB;AACjB;EACE,2CAA2C;EAC3C,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;AACA;EACE,wBAAwB;EACxB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;AACX;;AAEA,cAAc;AACd;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,SAAS;EACT,QAAQ;AACV;AACA;EACE,QAAQ;EACR,QAAQ;AACV;AACA;EACE,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;IACE,MAAM;EACR;EACA;;IAEE,cAAc;EAChB;AACF;;AAEA,cAAc;;AAEd;EACE,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;AACZ;AACA;;EAEE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,QAAQ;EACR,QAAQ;AACV;AACA;EACE,SAAS;EACT,QAAQ;AACV;AACA;EACE,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;AACF;;;AAGA,iBAAiB;;AAEjB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,WAAW;EACX,uBAAuB;EACvB,cAAc;AAChB;;;AAGA,iBAAiB;;AAEjB;EACE,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;;AAGA,cAAc;;AAEd;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA,UAAU;;AAEV;EACE,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,8CAA8C;EAC9C,kCAAkC;EAClC,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,yCAAyC;EAC3C;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["/* -------- */\n/* SHARED */\n/* -------- */\n#splash-page {\n  --ce-h1: var(--ce-marketing-h1);\n  --ce-h2: var(--ce-marketing-h2);\n  --ce-h3: var(--ce-marketing-h3);\n  --ce-h4: var(--ce-marketing-h4);\n  --ce-h5: var(--ce-marketing-h5);\n  --ce-h6: var(--ce-marketing-h6);\n  font-size: var(--ce-marketing-body-default);\n  line-height: 1.4;\n  background: #F6FAFD;\n}\n#splash-page h1,\n#splash-page h2,\n#splash-page h3,\n#splash-page h4,\n#splash-page h5,\n#splash-page h6\n{\n  font-family: var(--ce-font-family-title-marketing);\n}\n\n.gradient-text {\n    -webkit-text-fill-color: transparent;\n    -moz-text-fill-color: transparent;\n    -webkit-background-clip: text;\n    -moz-background-clip: text;\n    background-color: #4e44c2;\n    background-image: linear-gradient(90deg, #4e44c2, #f3617b);\n    background-size: 100%;\n}\n\nimg {\n  max-width: 100%;\n  height: auto;\n}\n\n.text-wrap {\n  padding: 0 1rem;\n}\n\n#splash-page section {\n  overflow: hidden;\n  padding: var(--section-padding) 3rem;\n}\n\n#splash-page h2,\n#splash-page h3,\n#splash-page h5 {\n  margin-top: 0;\n  padding-bottom: 0;\n  line-height: 1.25;\n}\n\n#splash-page h2 {\n  margin-bottom: 10px;\n}\n\n#splash-page h5 {\n  margin-bottom: 0;\n}\n\n.container {\n  display: flex;\n  gap: 30px;\n  flex-direction: column;\n  padding: 0 var(--ce-base-padding-default);\n}\n\n/* buttons */\n\n.button-group {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: var(--ce-base-padding-default);\n  padding: 30px 0;\n}\n.button-group a {\n  min-width: calc(50% - var(--ce-base-padding-default));\n}\n\n#splash-page .join-button,\n#splash-page .login-button {\n  flex: 1;\n}\n\n@media only screen and (min-width: 768px) {\n  #splash-page .join-button,\n  #splash-page .login-button {\n    width: 180px !important;\n    flex: initial;\n  }\n}\n\n/* icon bullets */\n\n.icon-bullets {\n  list-style: none;\n  padding: 20px 0;\n  margin: 0;\n  gap: 10px;\n  display: flex;\n  flex-direction: column;\n}\n\n.icon-bullets li {\n  display: flex;\n  align-items: flex-start;\n  gap: 15px;\n}\n\n.icon-bullets .icon-bullets {\n  padding: 0 3rem;\n  gap: 1.5rem;\n}\n\n#splash-page .icon-bullets h5 {\n  margin-bottom: 0;\n}\n\n\n.icon-wrap {\n  border-radius: 50%;\n  width: 16px;\n  height: 40px;\n  display: flex;\n  flex: none;\n  padding: 0;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n}\n.icon-wrap .fa-check {\n  font-size: 18px;\n  color: var(--ce-green-40);\n}\n@media only screen and (min-width: 768px) {\n  .icon-bullets .icon-bullets {\n    padding: 0 4rem;\n  }\n  .icon-wrap {\n    width: 40px;\n  }\n  .icon-wrap .fa-check {\n    font-size: 24px;\n  }\n}\n\n.icon-wrap img {\n  max-width: 100%;\n  max-height: 100%;\n  height: auto;\n  margin: 0 auto;\n}\n\n\n/* Graphics */\n.graphics svg {\n  width: 100%;\n  height: auto;\n}\n\n/* Mobile Portrait */\n@media only screen and (max-width: 767px) {\n  #splash-page section {\n    overflow: hidden;\n    padding: var(--section-padding) 1rem;\n  }\n\n  .col-2 > div:first-of-type {\n    padding-bottom: 1em;\n  }\n  .image-wrap img {\n    width: 60vh;\n    margin: 0 auto;\n    display: block;\n  }\n  .image-wrap {\n    height: 25vh;\n    min-height: 200px;\n  }\n  .text-wrap {\n    padding: 0;\n  }\n}\n/* Desktop */\n@media only screen and (min-width: 768px) {\n  .container {\n    max-width: 1200px;\n    margin: 0 auto;\n  }\n  .col-2 {\n    flex-direction: row;\n  }\n  .col-2 > div {\n    width: 50%;\n  }\n\n  .col-2 > .text-wrap {\n    width: 55%;\n  }\n  .col-2 > .image-wrap {\n    width: 45%;\n  }\n\n  .container.align-top {\n    align-items: flex-start;\n  }\n  .container.align-center {\n    align-items: center;\n  }\n  .container.align-stretch {\n    align-items: stretch;\n  }\n  .container.align-bottom {\n    align-items: flex-end;\n  }\n\n  .image-wrap.align-bottom .moving-image {\n    position: absolute;\n    width: 100%;\n  }\n}\n\n/* Blockquotes */\n\n.blockquote {\n  position: relative;\n  margin: var(--ce-base-padding-default) 0;\n}\n\n.quote {\n  position: relative;\n  font-family: var(--ce-font-family-title-marketing);\n  font-weight: var(--ce-font-weight-semibold);\n  font-size: var(--ce-h4);\n  line-height: 1.25;\n  margin: 0;\n}\n\n.quote::before {\n  content: open-quote;\n}\n.quote::after {\n  content: close-quote;\n}\n\n.cite {\n  display: block;\n  font-size: var(--ce-body-default);\n  margin-top: var(--ce-base-padding-default);\n  padding-left: 30px;\n  position: relative;\n}\n.cite::before {\n  content: '—';\n  position: absolute;\n  left: 7px;\n}\n\n\n/* -------- */\n/* SECTIONS */\n/* -------- */\n\n/* Hero */\n#splash-page section.hero {\n  background: linear-gradient(180deg, #E7E6F9 0%, #F3DFDB 100%);\n  padding: 0;\n  position: relative;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column-reverse;\n}\n#splash-page section.hero .container {\n  padding: 0;\n}\n.hero .text-wrap {\n  padding: 0 2rem;\n}\n@media only screen and (min-width: 768px) {\n  #splash-page section.hero {\n    flex-direction: row;\n  }\n  .hero .text-wrap {\n    padding: 0 2em 2em 4em;\n  }\n  .hero h2 {\n    max-width: 620px;\n  }\n  .hero .landscape-background,\n  .hero .text-background {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    overflow: hidden;\n  }\n  .hero .text-background {\n    background: linear-gradient(90deg, #F6FAFD 40%, rgba(255, 255, 255, 0.00) 60%);\n  }\n  .hero .landscape-background img {\n    max-width: 100%;\n    position: absolute;\n    max-height: 100%;\n    right: -25%;\n    bottom: 0;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .hero .landscape-background {\n    margin-bottom: -16%;\n    width: 231%;\n    left: -69.2%;\n    position: relative;\n    margin-top: -26%;\n  }\n}\n@media only screen and (min-width: 768px) {\n  section.hero .col-2 > .text-wrap {\n    width: 100%;\n  }\n  section.hero .col-2 .text-wrap-small {\n    width: 55%;\n  }\n}\n@media only screen and (min-width: 1024px) {\n  .hero .landscape-background img{\n    right: -300px;\n    bottom: -10%;\n  }\n}\n@media only screen and (min-width: 1600px) {\n  .hero .landscape-background img{\n    right: -15%;\n  }\n}\n@media only screen and (min-width: 1700px) {\n  .hero .landscape-background img{\n    right: -10%;\n  }\n}\n@media only screen and (min-width: 1900px) {\n  .hero .landscape-background img{\n    right: -5%;\n  }\n}\n@media only screen and (min-width: 2100px) {\n  .hero .landscape-background img{\n    right: 0;\n  }\n}\n@media only screen and (min-width: 2300px) {\n  .hero .landscape-background img{\n    right: 0;\n  }\n  .hero .text-background {\n    background: linear-gradient(90deg, #F6FAFD 40%, rgba(255, 255, 255, 0.00) 60%, #F6FAFD 95%);\n  }\n    #splash-page section.hero {\n    --hero-max-width: 2300px;\n    max-width: var(--hero-max-width);\n  }\n  #splash-page section.hero .container {\n    height: 620px;\n  }\n}\n\n.hero .what-is-mdh-description {\n  margin-bottom: 10px;\n}\n\n.image-wrap {\n  position: relative;\n}\n\n.moving-image {\n  position: absolute;\n}\n\n/* ----------- */\n/* ----------- */\n/* Trusted By */\n/* ----------- */\n/* ----------- */\n\n.trusted-by {\n  border-top: 1px solid var(--ce-grey-10);\n  border-bottom: 1px solid var(--ce-grey-10);\n  padding: var(--section-padding) 2rem;\n  background: #fff;\n}\n.trusted-by .header,\n.trusted-by p {\n  text-align: center;\n  color: var(--ce-grey-55);\n}\n.trusted-by .header {\n  margin: 0 auto 1em auto;\n}\n.trusted-by p {\n  margin: 1.5em auto 0 auto;\n  color: var(--default_text_color);\n  font-weight: 600;\n}\n.trusted-logos {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-around;\n  list-style-type: none;\n  height: 90px;\n  gap: 0;\n}\n\n.trusted-logos li {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 5px 15px;\n}\n\n.trusted-logos img {\n  max-height: 50px;\n  margin: 0 auto;\n  display: block;\n}\n\n.logo-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n/* Trusted logos fade animation */\n.trusted-logos-container {\n  position: relative;\n  min-height: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.trusted-logos.fade-in {\n  opacity: 1;\n  transition: opacity 0.6s ease-in-out;\n}\n\n.trusted-logos.fade-out {\n  opacity: 0;\n  transition: opacity 0.3s ease-in-out;\n}\n@media only screen and (max-width: 576px) {\n  .trusted-logos li {\n    width: 50%;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .trusted-logos {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    height: 200px;\n  }\n}\n\n.logo-text {\n  text-align: center;\n  max-height: 65px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  font-weight: 800;\n  color: var(--ce-grey-40);\n}\n@media only screen and (min-width: 768px) {\n  .logo-text {\n    font-size: 20px;\n  }\n}\n@media only screen and (min-width: 1200px) {\n  .logo-text {\n    font-size: 24px;\n  }\n}\n\n\n\n/* Section 1 */\n\n.section-1 {\n  background: var(--ce-grey-3);\n}\n\n@media only screen and (min-width: 768px) {\n  .section-1 .container {\n    flex-direction: row-reverse;\n  }\n}\n\n.section-wrap .icon-wrap {\n  color: var(--ce-blue-vivid-50);\n}\n\n.section-1 .image-wrap .moving-image,\n.section-1-dial {\n  position: absolute;\n  max-width: 50%;\n}\n.section-1-image-1 {\n  left: 2%;\n  top: 10%;\n}\n.section-1-image-2 {\n  left: 25%;\n  top: 20%;\n}\n.section-1-dial {\n  top: 10%;\n  left: 15%;\n  width: 50%;\n}\n\n@media only screen and (max-width: 767px) {\n  .section-1-image-1 {\n    top: 0;\n    left: 30%;\n  }\n  .section-1-image-2 {\n    top: 10%;\n    left: 10%;\n  }\n  .section-1-dial {\n    top: -10%;\n    left: 24%;\n  }\n}\n\n/* How it works */\n.section-2 {\n  background: var(--ce-gradient-open-horizon);\n  text-align: center;\n}\n.how-it-works-graphic {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  align-items: center;\n  list-style: none;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n.how-it-works-graphic img {\n  max-width: 100%;\n  max-height: 100%;\n}\n.how-it-works-graphic li{\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 2rem;\n  max-width: 150px;\n}\n@media screen and (min-width: 768px) {\n  .how-it-works-graphic li {\n    width: 31.3333%;\n    max-width: initial;\n  }\n  .how-it-works-graphic img{\n    max-height: 200px;\n    max-width: initial;\n  }\n}\n.how-it-works-graphic h3 div {\n  color: var(--ce-grey-55);\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  text-align: left;\n}\n.how-it-works-graphic span {\n  font-size: var(--ce-h1);\n  color: #fff;\n  line-height: 100%;\n  position: relative;\n  top: -1px;\n}\n\n/* section-3 */\n.section-3 {\n  background: #fff;\n}\n.section-3-section {\n  padding: 30px 0;\n}\n.section-3-section:first-of-type {\n  border-bottom: 1px solid var(--ce-grey-55);\n}\n.section-3-section img {\n  padding-bottom: 20px;\n}\n.section-3-section .icon-bullets {\n  padding-bottom: 0;\n}\n\n.list-button-group {\n  display: flex;\n  align-items: flex-end;\n  gap: 15px;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n\n.section-3 .image-wrap {\n  position: relative;\n  top: -30px;\n}\n\n.section-3 .image-wrap .moving-image,\n.section-3-dial {\n  position: absolute;\n  max-width: 50%;\n}\n.section-3-1 {\n  left: 36%;\n  top: 10%;\n}\n.section-3-2 {\n  left: 5%;\n  top: 23%;\n}\n.section-3-dial {\n  top: 50%;\n  left: 38%;\n  width: 50%;\n}\n\n@media only screen and (max-width: 767px) {\n  .section-3 .image-wrap {\n    top: 0;\n  }\n  .section-3 .image-wrap .moving-image,\n  .section-3-dial {\n    max-width: 45%;\n  }\n}\n\n/* section-4 */\n\n.section-4 {\n  background: var(--ce-gradient-evergreen-petrichor);\n}\n\n.section-4-dial {\n  position: absolute;\n  top: 0;\n  left: 10%;\n  width: 50%;\n}\n.section-4 .image-wrap .moving-image,\n.section-4-dial {\n  position: absolute;\n  max-width: 50%;\n}\n.section-4-image-1 {\n  left: 2%;\n  top: 10%;\n}\n.section-4-image-2 {\n  left: 25%;\n  top: 30%;\n}\n.section-4-dial {\n  top: 20%;\n  left: 15%;\n  width: 50%;\n}\n\n@media only screen and (max-width: 767px) {\n  .section-4 > .container {\n    flex-direction: column-reverse;\n  }\n  .section-4 .image-wrap {\n    top: 20px;\n  }\n  .section-4-image-1 {\n    top: 10%;\n  }\n  .section-4-image-2 {\n    top: 20%;\n  }\n  .section-4-dial {\n    top: 00%;\n  }\n}\n\n\n/* help section */\n\n.help-section {\n  text-align: center;\n  align-items: center;\n  background: #fff;\n}\n\n.help-center-button.intent-none.button.variant-filled {\n  border: 1px solid #000;\n  background-color: transparent;\n  color: #000;\n  width: 180px !important;\n  margin: 0 auto;\n}\n\n\n/* join section */\n\n.join-section{\n  background: var(--ce-gradient-midnight-moon);\n}\n\n.join-section .container {\n  text-align: center;\n  align-items: center;\n}\n\n\n/* app store */\n\n.app-store {\n  text-align: center;\n}\n\n.app-stores {\n  max-width: 100%;\n  padding: 0;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  gap: 1em;\n}\n\n.app-stores img {\n  height: 60px;\n  width: auto;\n}\n\n/* Login */\n\n.login-section {\n  background: var(--ce-gradient-midnight-moon);\n  padding: 150px 0;\n}\n\n@media only screen and (max-width: 767px) {\n  .login-section {\n    padding: 80px 20px;\n  }\n}\n\n.login-section h3 {\n  margin-top: 0px;\n}\n\n.login-card {\n  max-width: 660px;\n  margin: 0 auto 5px;\n  padding: 50px 70px;\n  border-radius: var(--ce-border-radius-default);\n  background-color: var(--ce-grey-1);\n  box-shadow: var(--ce-card-shadow);\n  border: 1px solid var(--ce-grey-20);\n}\n\n@media only screen and (max-width: 767px) {\n  .login-card {\n    padding: 30px;\n  }\n  .login-card .button-group {\n    flex-wrap: wrap;\n    padding: var(--ce-base-padding-default) 0;\n  }\n}\n\n.mdh-logo-login {\n  max-width: 240px;\n  margin-bottom: 1em;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
